import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationCellKeys } from './use-v2-reservationcell-find-query'

type CreateReservationCellBody = Parameters<typeof apiClient.v2.apiV2ReservationcellElCreate>[0]

const createReservationCell = async (body: CreateReservationCellBody) => {
  const { data } = await apiClient.v2.apiV2ReservationcellElCreate(body)
  return checkApiResponse(data)
}

export const useV2ReservationCellCreateMutation = ({ options }: MutationComposableParams<unknown, CreateReservationCellBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: createReservationCell,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationCellKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
